import type { OwnerPayload, WorldItemStatus, WorldSettings, WorldShell } from '../../shared/coloring/world/types';

import type { WorkKind } from './scene/art';

export type TreeWork = {
  id: string;
  kind: WorkKind;
  source: 'upload' | 'preset';
  variant?: number;
  hasName: boolean;
  imageUrl: string;
  createdAt: string;
  status: WorldItemStatus;
};
export type TreeWorld = WorldShell<WorldSettings> & { works: TreeWork[] };
export type TreeOwnerPayload = OwnerPayload<TreeWorld>;

const seg = encodeURIComponent;
export const treePaths = {
  manage: '/new-year-tree/manage',
  demo: '/new-year-tree/demo',
  display: (code: string) => `/new-year-tree/display/${seg(code)}`,
  add: (code: string) => `/new-year-tree/add/${seg(code)}`,
  draw: (code: string) => `/new-year-tree/draw/${seg(code)}`,
  capture: (code: string) => `/new-year-tree/capture/${seg(code)}`,
  print: (code: string) => `/new-year-tree/print/${seg(code)}`,
  moderate: (code: string) => `/new-year-tree/moderate/${seg(code)}`,
  /** Устаревшая ссылка по секрету: нужна только старым ссылкам, новые ведут на `moderate`. */
  moderator: (secret: string) => `/new-year-tree/moderator/${seg(secret)}`,
};

/** Постоянная демо-ёлка (её создаёт server/src/services/new-year-tree-demo-world.ts). */
export const TREE_DEMO_CODE = 'demo1';
